module.exports = __webpack_public_path__ + "static/WEDDING E&M-26-4b67cbd3245aee05039bc4ca44b54734.jpg";